/**
 * Walk through optional/default/nullable/effects wrappers to reach the core schema.
 */
export function unwrapSchema(schema) {
    let current = schema;
    while (true) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const def = current._def;
        if (!def)
            return current;
        const type = def?.type ?? def?.typeName;
        if (type === 'optional' ||
            type === 'default' ||
            type === 'nullable' ||
            type === 'readonly' ||
            type === 'catch' ||
            type === 'ZodOptional' ||
            type === 'ZodDefault' ||
            type === 'ZodNullable' ||
            type === 'ZodReadonly' ||
            type === 'ZodCatch') {
            if (def.innerType) {
                current = def.innerType;
                continue;
            }
        }
        if (type === 'pipe' || type === 'ZodPipeline' || type === 'ZodEffects') {
            if (def.in) {
                current = def.in;
                continue;
            }
            if (def.schema) {
                current = def.schema;
                continue;
            }
        }
        return current;
    }
}
/**
 * Read .meta() set on the schema via Zod v4 global registry.
 * Also unwraps — meta set on inner schema is visible through wrappers.
 */
export function readMeta(schema) {
    // Try direct .meta() first (Zod v4 exposes it on classic ZodType).
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const direct = schema.meta;
    if (typeof direct === 'function') {
        try {
            const m = direct.call(schema);
            if (m && typeof m === 'object')
                return m;
        }
        catch {
            /* ignore */
        }
    }
    // Try inner schema.
    const inner = unwrapSchema(schema);
    if (inner !== schema) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const innerMeta = inner.meta;
        if (typeof innerMeta === 'function') {
            try {
                const m = innerMeta.call(inner);
                if (m && typeof m === 'object')
                    return m;
            }
            catch {
                /* ignore */
            }
        }
    }
    return {};
}
//# sourceMappingURL=read-meta.js.map